<template>
	<div style="padding-top: 30px;">

		<el-form ref="form" :model="form" :rules="rules" label-width="80px">
			<el-form-item label="姓名" prop="name">
				<el-input v-model="form.name" placeholder="请输入姓名" />
			</el-form-item>
			<el-form-item label="手机号码" prop="phone">
				<el-input v-model="form.phone" placeholder="请输入手机号码" />
			</el-form-item>
			<el-form-item label="联系地址" prop="address">
				<el-input v-model="form.address" placeholder="请输入联系地址" />
			</el-form-item>
			<el-form-item label="邮政编码" prop="postcode">
				<el-input v-model="form.postcode" placeholder="请输入邮政编码" />
			</el-form-item>
			<el-form-item label="电子邮箱" prop="email">
				<el-input v-model="form.email" placeholder="请输入电子邮箱" />
			</el-form-item>
			<el-form-item label="留言标题" prop="title">
				<el-input v-model="form.title" placeholder="请输入留言标题" />
			</el-form-item>
			<el-form-item label="留言内容" prop="msgContent">
				<el-input v-model="form.msgContent" type="textarea" :rows="6" placeholder="请输入内容（限字2000）" />
			</el-form-item>
			<el-form-item label="验证码" prop="code">

				<el-input v-model="form.code" auto-complete="off" placeholder="请输入验证码" style="width: 63%">
				</el-input>
				<div class="login-code">
					<img :src="code_img" @click="getCode" class="login-code-img" />
				</div>
			</el-form-item>

			<div style="text-align: center;margin-top: 40px;">

				<el-button type="primary" @click="submitForm" style="width: 120px;font-size: 16px;">提 交</el-button>
			</div>
		</el-form>

	</div>

</template>

<script>
	export default {
		name: 'index',
		data() {
			var checkPhone = (rule, value, callback) => { //手机号码校验
				const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/
				// if (!value) {
				// 	return callback(new Error('电话号码不能为空'))
				// }

				if (value) {
					if (!Number.isInteger(+value)) {
						callback(new Error('请输入数字值'))
					} else {
						if (phoneReg.test(value)) {
							callback()
						} else {
							callback(new Error('电话号码格式不正确'))
						}
					}
				} else {
					callback()
				}

			}

			var checkEmail = (rule, value, callback) => { //邮箱校验
				const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/

				if (!value) {
					return callback(new Error('电子邮箱不能为空'))
				}
				if (mailReg.test(value)) {
					callback()
				} else {
					callback(new Error('请输入正确的邮箱格式'))
				}

			}


			return {
				// 表单参数
				form: {},
				// 表单校验
				rules: {
					name: [{
						required: true,
						message: "姓名不能为空",
						trigger: "blur"
					}],
					phone: [{
						validator: checkPhone,
						trigger: 'blur'
					}],
					email: [{
						validator: checkEmail,
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: "留言标题不能为空",
						trigger: "blur"
					}],
					msgContent: [{
							required: true,
							message: "留言内容不能为空",
							trigger: "blur"
						},
						{
							min: 0,
							max: 2000,
							message: '限字2000',
							trigger: 'blur'
						}
					],
					code: [{
						required: true,
						message: "验证码不能为空",
						trigger: "blur"
					}],
				},
				code_img: '',
				uuid: ''

			}
		},
		methods: {
			getCode() {
				this.axios.get('//hrdz.ccxmttech.com/prod-api/api/hbwwjlyb/system/content/api/captchaImage').then(res => {

					if (res.data.code == 200) {
						this.code_img = 'data:image/gif;base64,' + res.data.img;
						this.uuid = res.data.uuid;

					} else {
						this.$message({
							message: res.data.msg,
							type: 'error'
						});

					}

				})
			},
			submitForm() {


				this.$refs["form"].validate(valid => {
					if (valid) {
						let uuid = {
							uuid: this.uuid
						}
						this.axios({
							//请求方式
							method: 'post',
							//后端接口路径
							url: '//hrdz.ccxmttech.com/prod-api/api/hbwwjlyb/system/content/api/add',
							//注意这里使用的是params,该属性负责把属性名和属性值添加到url后面，一般和get配合使用，但也能    和post配合使用
							params: {
								...this.form,
								...uuid
							}
						}).then(res => {

							if (res.data.code == 200) {


								this.form = {
									name: null,
									phone: null,
									address: null,
									postcode: null,
									email: null,
									title: null,
									msgContent: null
								}
								this.$message({
									message: '提交成功',
									type: 'success'
								});
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error'
								});

							}

							this.getCode()

						})
					}
				});




			}



		},
		mounted() {
			this.getCode()

		}
	}
</script>

<style>
	.login-code {
		width: 33%;
		height: 38px;
		float: right;

	}

	.login-code img {
		cursor: pointer;
		vertical-align: middle;
	}

	.login-code-img {
		height: 38px;
	}
</style>